import { render, staticRenderFns } from "./EnquiryCabinet.vue?vue&type=template&id=5b409e26&scoped=true&"
import script from "./EnquiryCabinet.vue?vue&type=script&lang=js&"
export * from "./EnquiryCabinet.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryCabinet.vue?vue&type=style&index=0&id=5b409e26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b409e26",
  null
  
)

export default component.exports